// extracted by mini-css-extract-plugin
export default {"breadcrumbs":"TriangleBreadcrumbsLayout_breadcrumbs__pcvgY"};